// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var $$String = require("bs-platform/lib/js/string.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Phoneme$Phonics = require("./Phoneme.bs.js");

function toString(word) {
  var __x = List.map((function (phoneme) {
          return phoneme.sound;
        }), word);
  return List.fold_right((function (phoneme, acc) {
                return phoneme + ((
                          acc === "" ? "" : ","
                        ) + acc);
              }), __x, "");
}

function fromString(word) {
  return List.flatten(List.map((function (__x) {
                    return Belt_Option.mapWithDefault(__x, /* [] */0, (function (p) {
                                  return /* :: */[
                                          p,
                                          /* [] */0
                                        ];
                                }));
                  }), List.map(Phoneme$Phonics.fromString, $$String.split_on_char(/* "," */44, word))));
}

function findPrev(_words, word) {
  while(true) {
    var words = _words;
    var wordStr = toString(word);
    if (words) {
      var rest = words[1];
      if (rest) {
        if (toString(rest[0]) === wordStr) {
          return words[0];
        } else {
          _words = rest;
          continue ;
        }
      } else {
        return ;
      }
    } else {
      return ;
    }
  };
}

function findNext(_words, word) {
  while(true) {
    var words = _words;
    var wordStr = toString(word);
    if (words) {
      var rest = words[1];
      if (rest) {
        if (toString(words[0]) === wordStr) {
          return rest[0];
        } else {
          _words = rest;
          continue ;
        }
      } else {
        return ;
      }
    } else {
      return ;
    }
  };
}

function Word(Props) {
  var word = Props.word;
  var onDeleteClickedOpt = Props.onDeleteClicked;
  var onClickOpt = Props.onClick;
  var onDeleteClicked = onDeleteClickedOpt !== undefined ? onDeleteClickedOpt : (function (param) {
        return /* () */0;
      });
  var onClick = onClickOpt !== undefined ? onClickOpt : (function (param) {
        return /* () */0;
      });
  return React.createElement("div", {
              className: "word",
              onClick: (function (_evt) {
                  return Curry._1(onClick, /* () */0);
                })
            }, $$Array.of_list(List.mapi((function (index, phoneme) {
                        return React.createElement(Phoneme$Phonics.make, {
                                    phoneme: phoneme,
                                    key: String(index)
                                  });
                      }), word)), React.createElement("button", {
                  className: "delete-word-button",
                  title: "Delete Word",
                  onClick: (function (_evt) {
                      _evt.stopPropagation();
                      return Curry._1(onDeleteClicked, /* () */0);
                    })
                }));
}

var make = Word;

exports.toString = toString;
exports.fromString = fromString;
exports.findPrev = findPrev;
exports.findNext = findNext;
exports.make = make;
/* react Not a pure module */
